module.exports = __webpack_public_path__ + "img/plane-category.f9d637f3.jpg";